<template>
  <div class="row">
    <div class="col-md-12">
      <div class="d-flex justify-content-center">
        <vue-justgage ref="g1" id="g1" style="width:400px; height:auto" class="gauge"></vue-justgage>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import vueJustgage from 'vue-justgage';
Vue.use(vueJustgage);
export default {
  name: 'Singer',
  props: {
    is_singer: Boolean,
    singer: Number,
  },
  data: function () {
    return {
      // gauge: null,
      dflt: {
        min: 0,
        max: 100,
        decimals: 0,
        gaugeWidthScale: 0.6,
        relativeGaugeSize: true,
        title: "コーラス声の質",
        titleFontColor: "0000FFA9",
        refreshAnimationTime: 30,
        startAnimationTime: 1,
      },
      g1: null,
    }
  },
  mounted: async function () {
    /*this.gauge = new JustGage({
      id: "gauge",
      value: 0,
      min: 0,
      max: 100,
      decimals: 2,
      gaugeWidthScale: 0.6
    })
    console.log(this.gauge)
    console.log(this.is_singer)*/
    this.g1 = this.$refs.g1.draw({
      id: 'g1',
      value: 0,
      defaults: this.dflt
    });
  },
  methods: {
  },
  watch: {
    singer: function (singerval, old) {
      console.log(singerval, old)
      //this.gauge.refresh(singerval)
      this.g1.refresh(singerval)
      console.log(this.is_singer)
    }
  }
}
</script>

<style></style>